import { render, staticRenderFns } from "./Kayıt.vue?vue&type=template&id=6f884385&"
import script from "./Kayıt.vue?vue&type=script&lang=js&"
export * from "./Kayıt.vue?vue&type=script&lang=js&"
import style0 from "./Kayıt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports